(()=>{
  const root=document.querySelector('[data-it-native-settings]');
  if(!root)return;

  const q=s=>root.querySelector(s);
  const cards=[...root.querySelectorAll('[data-it-setting-card]')];
  const config=q('[data-it-setting-config]');
  const topMetal=q('[data-it-filter-metal]');
  const topShape=q('[data-it-filter-shape]');
  const filterStatus=q('[data-it-filter-status]');
  const metalPicker=q('[data-it-metal-picker]');
  const metalTrigger=q('[data-it-metal-trigger]');
  const metalMenu=q('[data-it-metal-menu]');
  const metalTriggerLabel=q('[data-it-metal-trigger-label]');
  const metalTriggerSwatch=q('[data-it-metal-trigger-swatch]');
  const metalOptions=[...root.querySelectorAll('[data-it-metal-option]')];
  const shapePicker=q('[data-it-shape-picker]');
  const shapeTrigger=q('[data-it-shape-trigger]');
  const shapeMenu=q('[data-it-shape-menu]');
  const shapeTriggerLabel=q('[data-it-shape-trigger-label]');
  const shapeTriggerIcon=q('[data-it-shape-trigger-icon]');
  const shapeOptions=[...root.querySelectorAll('[data-it-shape-option]')];
  const metalSelect=q('[data-it-metal-type]');
  const caratSelect=q('[data-it-gold-carat]');
  const shapeSelect=q('[data-it-shape-select]');
  const titleEl=q('[data-it-selected-title]');
  const summaryEl=q('[data-it-selected-summary]');
  const priceEl=q('[data-it-selected-price]');
  const imageEl=q('[data-it-selected-image]');
  const statusEl=q('[data-it-config-status]');
  const continueEl=q('[data-it-setting-continue]');
  const handoffBase=root.dataset.handoffBase||'/pages/design-your-ring';
  const cache=new Map();
  let selectedCard=null,selectedProduct=null,selectedVariant=null,selectedProductId='',selectedTitle='',requestToken=0,filterToken=0,routeActive=false;

  const isNativeRoute=()=>document.documentElement.dataset.itRingRoute==='native';
  const push=(event,extra={})=>{
    if(!routeActive)return;
    window.dataLayer=window.dataLayer||[];
    window.dataLayer.push({event,builder_route:'native-setting-first',page_path:location.pathname+location.search,...extra});
  };
  const slug=v=>String(v||'').trim().toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
  const cardList=(card,name)=>String(card.dataset[name]||'').split('|').filter(Boolean);
  const money=cents=>{
    const amount=Number(cents||0)/100,currency=window.Shopify?.currency?.active||'GBP';
    try{return new Intl.NumberFormat(document.documentElement.lang||'en-GB',{style:'currency',currency,minimumFractionDigits:0,maximumFractionDigits:2}).format(amount)}catch(e){return `£${Number(amount).toLocaleString('en-GB',{minimumFractionDigits:0,maximumFractionDigits:2})}`}
  };
  const setImage=(img,url,alt='')=>{
    if(!img||!url)return;
    img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=url;img.alt=alt||'';
  };
  const neutralCardAlt=card=>`${card?.dataset.productTitle||'Engagement ring'} engagement ring setting`;
  const loadProduct=card=>{
    const url=card.dataset.productJson;
    if(!url)return Promise.reject(new Error('Missing product data URL'));
    if(!cache.has(url))cache.set(url,fetch(url,{headers:{Accept:'application/json'}}).then(r=>{if(!r.ok)throw new Error(`Product data request failed (${r.status})`);return r.json();}).catch(e=>{cache.delete(url);throw e;}));
    return cache.get(url);
  };
  const optionIndex=(product,name)=>(product?.options||[]).findIndex(o=>{
    const optionName=String(typeof o==='string'?o:o?.name||'').trim().toLowerCase();
    const wanted=String(name||'').trim().toLowerCase();
    if(wanted==='metal')return optionName.includes('metal');
    if(wanted==='shape')return optionName.includes('shape');
    return optionName===wanted;
  });
  const optionValue=(variant,index)=>index<0||!variant?'':String(Array.isArray(variant.options)?variant.options[index]||'':variant[`option${index+1}`]||'');
  const variantImage=v=>typeof v?.featured_image==='string'?v.featured_image:String(v?.featured_image?.src||v?.featured_image?.url||'');
  const variants=product=>(Array.isArray(product?.variants)?product.variants:[]).filter(v=>v&&v.available!==false);

  const metalMeta=value=>{
    const raw=String(value||'').trim(),lower=raw.toLowerCase();
    if(lower.includes('platinum'))return{key:'platinum',label:'Platinum',carat:'',raw};
    const colour=lower.includes('white')?'White':lower.includes('yellow')?'Yellow':lower.includes('rose')?'Rose':'';
    const m=raw.match(/(9|14|18)\s*k/i),carat=m?m[1]:'';
    return{key:colour?`${colour.toLowerCase()}-gold`:'gold',label:colour?`${colour} Gold`:'Gold',carat,raw};
  };
  const unique=(items,keyFn)=>{const seen=new Set();return items.filter(item=>{const k=keyFn(item);if(!k||seen.has(k))return false;seen.add(k);return true;});};
  const variantMatches=(product,variant,metalKey,shapeKey)=>{
    const mi=optionIndex(product,'Metal'),si=optionIndex(product,'Shape');
    const vm=mi>=0?metalMeta(optionValue(variant,mi)).key:'';
    const vs=si>=0?slug(optionValue(variant,si)):'';
    return(!metalKey||mi<0||vm===metalKey)&&(!shapeKey||si<0||vs===shapeKey);
  };
  const preferredVariant=(product,metalKey='',shapeKey='')=>variants(product).find(v=>variantMatches(product,v,metalKey,shapeKey))||variants(product)[0]||null;

  if(metalMenu){
    if(!metalMenu.id)metalMenu.id=`it-metal-picker-menu-${root.id||'ring-settings'}`;
    metalTrigger?.setAttribute('aria-controls',metalMenu.id);
  }
  if(shapeMenu){
    if(!shapeMenu.id)shapeMenu.id=`it-shape-picker-menu-${root.id||'ring-settings'}`;
    shapeTrigger?.setAttribute('aria-controls',shapeMenu.id);
  }
  if(filterStatus){
    filterStatus.setAttribute('role','status');
    filterStatus.setAttribute('aria-live','polite');
    filterStatus.setAttribute('aria-atomic','true');
  }

  const swatchClass=value=>`it-metal-picker__swatch--${value||'all'}`;
  const syncMetalPicker=value=>{
    const selected=metalOptions.find(option=>(option.dataset.value||'')===(value||''))||metalOptions[0];
    metalOptions.forEach(option=>{
      const active=option===selected;
      option.classList.toggle('is-selected',active);
      option.setAttribute('aria-selected',active?'true':'false');
      option.tabIndex=active?0:-1;
    });
    if(metalTriggerLabel)metalTriggerLabel.textContent=selected?.textContent?.trim()||'All metals';
    if(metalTriggerSwatch){
      metalTriggerSwatch.className=`it-metal-picker__swatch ${swatchClass(selected?.dataset.value||'')}`;
    }
  };
  const closeMetalPicker=()=>{
    if(metalMenu)metalMenu.hidden=true;
    if(metalTrigger)metalTrigger.setAttribute('aria-expanded','false');
  };
  const toggleMetalPicker=()=>{
    if(!metalMenu||!metalTrigger||!routeActive)return;
    const opening=metalMenu.hidden;
    metalMenu.hidden=!opening;
    metalTrigger.setAttribute('aria-expanded',opening?'true':'false');
    if(opening)(metalOptions.find(option=>option.classList.contains('is-selected'))||metalOptions[0])?.focus();
  };
  const focusMetalOption=index=>{
    if(!metalOptions.length)return;
    const next=Math.max(0,Math.min(index,metalOptions.length-1));
    metalOptions.forEach((option,i)=>{option.tabIndex=i===next?0:-1;});
    metalOptions[next]?.focus();
  };

  const syncShapePicker=value=>{
    const selected=shapeOptions.find(option=>(option.dataset.value||'')===(value||''))||shapeOptions[0];
    shapeOptions.forEach(option=>{
      const active=option===selected;
      option.classList.toggle('is-selected',active);
      option.setAttribute('aria-selected',active?'true':'false');
      option.tabIndex=active?0:-1;
    });
    if(shapeTriggerLabel)shapeTriggerLabel.textContent=selected?.textContent?.trim()||'All shapes';
    if(shapeTriggerIcon){
      const key=selected?.dataset.value||'all';
      shapeTriggerIcon.className=`it-shape-icon it-shape-icon--${key||'all'}`;
    }
  };
  const closeShapePicker=()=>{
    if(shapeMenu)shapeMenu.hidden=true;
    if(shapeTrigger)shapeTrigger.setAttribute('aria-expanded','false');
  };
  const toggleShapePicker=()=>{
    if(!shapeMenu||!shapeTrigger||!routeActive)return;
    const opening=shapeMenu.hidden;
    shapeMenu.hidden=!opening;
    shapeTrigger.setAttribute('aria-expanded',opening?'true':'false');
    if(opening)(shapeOptions.find(option=>option.classList.contains('is-selected'))||shapeOptions[0])?.focus();
  };
  const focusShapeOption=index=>{
    if(!shapeOptions.length)return;
    const next=Math.max(0,Math.min(index,shapeOptions.length-1));
    shapeOptions.forEach((option,i)=>{option.tabIndex=i===next?0:-1;});
    shapeOptions[next]?.focus();
  };

  const setStatus=(message,error=false)=>{if(statusEl){statusEl.textContent=message||'';statusEl.classList.toggle('is-error',!!error);}};
  const setControlsDisabled=disabled=>{
    [metalSelect,caratSelect,shapeSelect].forEach(c=>{if(c)c.disabled=!!disabled;});
    if(continueEl){continueEl.classList.toggle('is-disabled',!!disabled);continueEl.setAttribute('aria-disabled',disabled?'true':'false');}
  };
  const resetConfig=()=>{++requestToken;selectedCard?.classList.remove('is-selected');selectedCard=null;selectedProduct=null;selectedVariant=null;if(config)config.hidden=true;};

  const cardMatches=card=>{
    const metal=topMetal?.value||'',shape=topShape?.value||'';
    if(metal&&shape){
      const combos=cardList(card,'combos');
      if(combos.length)return combos.includes(`${metal}~${shape}`);
    }
    return(!metal||cardList(card,'metals').includes(metal))&&(!shape||cardList(card,'shapes').includes(shape));
  };
  const syncCardImage=async(card,token)=>{
    const img=card.querySelector('.it-native-setting-card__media img'),badge=card.querySelector('[data-it-card-shape-label]');
    if(!img)return;
    const metal=topMetal?.value||'',shape=topShape?.value||'';
    if(!shape){
      const map={'white-gold':'metalImageWhiteGold','yellow-gold':'metalImageYellowGold','rose-gold':'metalImageRoseGold','platinum':'metalImagePlatinum'};
      const matchingMetalUrl=metal?card.dataset[map[metal]]:'';
      const url=matchingMetalUrl||card.dataset.productImage;
      const alt=matchingMetalUrl&&metal?`${card.dataset.productTitle||'Engagement ring setting'} in ${topMetal.options[topMetal.selectedIndex].text}`:neutralCardAlt(card);
      setImage(img,url,alt);
      if(badge){badge.hidden=true;badge.textContent='';}
      return;
    }
    try{
      const product=await loadProduct(card);
      if(token!==filterToken||card.hidden)return;
      const variant=preferredVariant(product,metal,shape);
      const matchingVariantUrl=variantImage(variant);
      setImage(img,matchingVariantUrl||card.dataset.productImage,matchingVariantUrl?`${card.dataset.productTitle||'Engagement ring setting'} for ${topShape.options[topShape.selectedIndex].text} centre diamond`:neutralCardAlt(card));
      if(badge){
        if(matchingVariantUrl){badge.textContent=topShape.options[topShape.selectedIndex].text;badge.hidden=false;}
        else{badge.textContent='';badge.hidden=true;}
      }
    }catch(e){setImage(img,card.dataset.productImage,neutralCardAlt(card));if(badge){badge.textContent='';badge.hidden=true;}}
  };
  const applyTopFilters=()=>{
    if(!routeActive)return;
    const token=++filterToken;let shown=0;
    cards.forEach(card=>{const visible=cardMatches(card);card.hidden=!visible;if(visible){shown++;syncCardImage(card,token);}});
    if(selectedCard?.hidden)resetConfig();
    if(filterStatus)filterStatus.textContent=`${shown} setting${shown===1?'':'s'} shown`;
    push('ring_setting_filters_changed',{metal_filter:topMetal?.value||'all',shape_filter:topShape?.value||'all',settings_shown:shown});
  };

  const selectedMetalRaw=()=>{
    const mi=optionIndex(selectedProduct,'Metal');if(mi<0)return'';
    const typeKey=metalSelect?.value||'',carat=caratSelect?.value||'';
    return variants(selectedProduct).map(v=>optionValue(v,mi)).find(value=>{const meta=metalMeta(value);return meta.key===typeKey&&(typeKey==='platinum'||meta.carat===carat);})||'';
  };
  const populateMetalTypes=initialMetal=>{
    if(!metalSelect)return;
    const mi=optionIndex(selectedProduct,'Metal'),values=unique(variants(selectedProduct).map(v=>metalMeta(optionValue(v,mi))),m=>m.key);
    metalSelect.innerHTML='';values.forEach(meta=>{const o=document.createElement('option');o.value=meta.key;o.textContent=meta.label;metalSelect.appendChild(o);});
    const preferred=topMetal?.value||metalMeta(initialMetal).key;if(values.some(m=>m.key===preferred))metalSelect.value=preferred;
  };
  const populateCarats=initialCarat=>{
    if(!caratSelect)return;
    const mi=optionIndex(selectedProduct,'Metal'),typeKey=metalSelect?.value||'';caratSelect.innerHTML='';
    if(typeKey==='platinum'){const o=document.createElement('option');o.value='';o.textContent='950 Platinum';caratSelect.appendChild(o);caratSelect.disabled=true;return;}
    const carats=unique(variants(selectedProduct).map(v=>metalMeta(optionValue(v,mi))).filter(m=>m.key===typeKey&&m.carat),m=>m.carat);
    carats.forEach(meta=>{const o=document.createElement('option');o.value=meta.carat;o.textContent=`${meta.carat}ct`;caratSelect.appendChild(o);});
    caratSelect.disabled=false;if(carats.some(m=>m.carat===initialCarat))caratSelect.value=initialCarat;
  };
  const populateShapes=initialShape=>{
    if(!shapeSelect)return;
    const si=optionIndex(selectedProduct,'Shape');shapeSelect.innerHTML='';
    if(si<0){const o=document.createElement('option');o.value='';o.textContent='As shown';shapeSelect.appendChild(o);shapeSelect.disabled=true;return;}
    const mi=optionIndex(selectedProduct,'Metal'),metalRaw=selectedMetalRaw();
    const shapes=unique(variants(selectedProduct).filter(v=>mi<0||!metalRaw||optionValue(v,mi)===metalRaw).map(v=>optionValue(v,si)).filter(Boolean),v=>v);
    shapes.forEach(value=>{const o=document.createElement('option');o.value=value;o.textContent=value;shapeSelect.appendChild(o);});
    const top=topShape?.value||'',preferred=shapes.find(v=>slug(v)===top);
    if(preferred)shapeSelect.value=preferred;else if(shapes.includes(initialShape))shapeSelect.value=initialShape;
    shapeSelect.disabled=shapes.length<=1;
  };
  const updateSelectedVariant=()=>{
    if(!selectedProduct)return;
    const mi=optionIndex(selectedProduct,'Metal'),si=optionIndex(selectedProduct,'Shape'),metalRaw=selectedMetalRaw(),shape=shapeSelect?.value||'';
    selectedVariant=variants(selectedProduct).find(v=>(mi<0||!metalRaw||optionValue(v,mi)===metalRaw)&&(si<0||!shape||optionValue(v,si)===shape))||variants(selectedProduct)[0]||null;
    if(!selectedVariant){setStatus('No available variant matches this combination. Please choose another option.',true);setControlsDisabled(true);return;}
    const actualMetal=mi>=0?optionValue(selectedVariant,mi):'',actualShape=si>=0?optionValue(selectedVariant,si):'',formattedPrice=money(selectedVariant.price);
    if(priceEl)priceEl.textContent=formattedPrice;if(summaryEl)summaryEl.textContent=[actualMetal,actualShape?`${actualShape} centre`:null].filter(Boolean).join(' · ');
    const matchingVariantUrl=variantImage(selectedVariant);
    setImage(imageEl,matchingVariantUrl||selectedCard?.dataset.productImage,matchingVariantUrl?`${selectedTitle} ${actualMetal} ${actualShape}`.trim():`${selectedTitle} engagement ring setting`);
    const url=new URL(handoffBase,location.origin);
    url.searchParams.set('stage','Add Diamond');url.searchParams.set('settingId',selectedProductId);url.searchParams.set('settingVariantId',selectedVariant.id);url.searchParams.set('activeTab','Natural');url.searchParams.set('queryLabGrown','false');url.searchParams.set('sort','PRICE-ASC');
    if(continueEl){continueEl.href=url.pathname+url.search;continueEl.dataset.variantId=selectedVariant.id;continueEl.dataset.variantPrice=formattedPrice;continueEl.dataset.variantMetal=actualMetal;continueEl.dataset.variantShape=actualShape;continueEl.classList.remove('is-disabled');continueEl.setAttribute('aria-disabled','false');}
    setStatus('Your selected setting will carry into the guided live diamond stage.');
  };
  const configureProduct=product=>{
    selectedProduct=product;const initial=preferredVariant(product,topMetal?.value||'',topShape?.value||'');if(!initial)throw new Error('No available variants');
    const mi=optionIndex(product,'Metal'),si=optionIndex(product,'Shape'),initialMetal=mi>=0?optionValue(initial,mi):'',initialShape=si>=0?optionValue(initial,si):'',initialCarat=metalMeta(initialMetal).carat;
    populateMetalTypes(initialMetal);populateCarats(initialCarat);populateShapes(initialShape);setControlsDisabled(false);
    if(caratSelect&&metalSelect?.value==='platinum')caratSelect.disabled=true;if(shapeSelect&&shapeSelect.options.length<=1)shapeSelect.disabled=true;
    updateSelectedVariant();
    push('ring_setting_options_loaded',{setting_id:selectedProductId,setting_title:selectedTitle,available_variant_count:variants(product).length,metal_type_count:metalSelect?.options.length||0,shape_count:shapeSelect?.options.length||0});
  };
  const chooseCard=async card=>{
    if(!routeActive)return;
    const token=++requestToken;cards.forEach(c=>c.classList.remove('is-selected'));card.classList.add('is-selected');
    selectedCard=card;selectedProduct=null;selectedVariant=null;selectedProductId=card.dataset.productId||'';selectedTitle=card.dataset.productTitle||'';
    if(titleEl)titleEl.textContent=selectedTitle;setImage(imageEl,card.querySelector('.it-native-setting-card__media img')?.src||card.dataset.productImage,`${selectedTitle} selected ring setting`);if(summaryEl)summaryEl.textContent='';if(priceEl)priceEl.textContent=card.dataset.productPrice||'';
    if(config){config.hidden=false;config.setAttribute('aria-busy','true');}setControlsDisabled(true);setStatus('Loading available metal, gold carat and centre-shape options…');
    const button=card.querySelector('[data-it-setting-choose]'),original=button?.textContent;if(button){button.disabled=true;button.textContent='Loading options…';}
    push('ring_setting_selected',{setting_id:selectedProductId,setting_title:selectedTitle});requestAnimationFrame(()=>config?.scrollIntoView({behavior:'smooth',block:'nearest'}));
    try{const product=await loadProduct(card);if(token!==requestToken)return;configureProduct(product);}catch(error){if(token!==requestToken)return;console.error('[Imperial Time ring picker]',error);setStatus('We could not load this setting’s options. Please choose another setting or contact our Kensington team.',true);setControlsDisabled(true);push('ring_setting_options_error',{setting_id:selectedProductId,error_message:String(error?.message||error)});}finally{if(button){button.disabled=false;button.textContent=original||'Choose this setting';}if(token===requestToken)config?.removeAttribute('aria-busy');}
  };
  const refreshAfterMetal=()=>{
    if(!routeActive||!selectedProduct)return;const mi=optionIndex(selectedProduct,'Metal'),first=variants(selectedProduct).find(v=>metalMeta(optionValue(v,mi)).key===metalSelect?.value),initialCarat=first?metalMeta(optionValue(first,mi)).carat:'',si=optionIndex(selectedProduct,'Shape'),initialShape=first&&si>=0?optionValue(first,si):'';
    populateCarats(initialCarat);populateShapes(initialShape);updateSelectedVariant();
  };
  const refreshAfterCarat=()=>{
    if(!routeActive||!selectedProduct)return;const mi=optionIndex(selectedProduct,'Metal'),si=optionIndex(selectedProduct,'Shape'),metalRaw=selectedMetalRaw(),first=variants(selectedProduct).find(v=>mi<0||optionValue(v,mi)===metalRaw),initialShape=first&&si>=0?optionValue(first,si):'';
    populateShapes(initialShape);updateSelectedVariant();
  };

  root.addEventListener('click',event=>{
    if(!routeActive)return;
    const trigger=event.target.closest('[data-it-metal-trigger]');
    if(trigger){event.preventDefault();toggleMetalPicker();return;}
    const metalOption=event.target.closest('[data-it-metal-option]');
    if(metalOption){
      event.preventDefault();
      if(topMetal){topMetal.value=metalOption.dataset.value||'';syncMetalPicker(topMetal.value);topMetal.dispatchEvent(new Event('change',{bubbles:true}));}
      closeMetalPicker();
      metalTrigger?.focus();
      return;
    }
    const shapeOpen=event.target.closest('[data-it-shape-trigger]');
    if(shapeOpen){event.preventDefault();toggleShapePicker();return;}
    const shapeOption=event.target.closest('[data-it-shape-option]');
    if(shapeOption){
      event.preventDefault();
      if(topShape){topShape.value=shapeOption.dataset.value||'';syncShapePicker(topShape.value);topShape.dispatchEvent(new Event('change',{bubbles:true}));}
      closeShapePicker();
      shapeTrigger?.focus();
      return;
    }
    const choose=event.target.closest('[data-it-setting-choose]');if(choose){const card=choose.closest('[data-it-setting-card]');if(card)chooseCard(card);return;}
    if(event.target.closest('[data-it-setting-change]')){resetConfig();root.querySelector('[data-it-setting-card]:not([hidden])')?.scrollIntoView({behavior:'smooth',block:'start'});push('ring_setting_change');return;}
    const next=event.target.closest('[data-it-setting-continue]');if(next){if(next.getAttribute('aria-disabled')==='true'){event.preventDefault();return;}push('ring_setting_continue',{setting_id:selectedProductId,setting_title:selectedTitle,setting_variant_id:next.dataset.variantId||'',setting_price:next.dataset.variantPrice||'',setting_metal:next.dataset.variantMetal||'',setting_shape:next.dataset.variantShape||'',link_url:next.href||''});}
  });
  document.addEventListener('click',event=>{
    if(metalPicker&&!metalPicker.contains(event.target))closeMetalPicker();
    if(shapePicker&&!shapePicker.contains(event.target))closeShapePicker();
  });
  document.addEventListener('keydown',event=>{
    if(event.key==='Escape'&&metalMenu&&!metalMenu.hidden){closeMetalPicker();metalTrigger?.focus();}
    if(event.key==='Escape'&&shapeMenu&&!shapeMenu.hidden){closeShapePicker();shapeTrigger?.focus();}
  });
  metalTrigger?.addEventListener('keydown',event=>{
    if(!routeActive||!['ArrowDown','ArrowUp'].includes(event.key))return;
    event.preventDefault();
    if(metalMenu?.hidden)toggleMetalPicker();
    const selectedIndex=Math.max(0,metalOptions.findIndex(option=>option.classList.contains('is-selected')));
    focusMetalOption(event.key==='ArrowUp'?Math.max(0,selectedIndex-1):Math.min(metalOptions.length-1,selectedIndex+1));
  });
  metalMenu?.addEventListener('keydown',event=>{
    if(!routeActive)return;
    const current=Math.max(0,metalOptions.indexOf(document.activeElement));
    if(event.key==='ArrowDown'){event.preventDefault();focusMetalOption((current+1)%metalOptions.length);}
    else if(event.key==='ArrowUp'){event.preventDefault();focusMetalOption((current-1+metalOptions.length)%metalOptions.length);}
    else if(event.key==='Home'){event.preventDefault();focusMetalOption(0);}
    else if(event.key==='End'){event.preventDefault();focusMetalOption(metalOptions.length-1);}
    else if(event.key==='Escape'){event.preventDefault();closeMetalPicker();metalTrigger?.focus();}
  });
  shapeTrigger?.addEventListener('keydown',event=>{
    if(!routeActive||!['ArrowDown','ArrowUp'].includes(event.key))return;
    event.preventDefault();
    if(shapeMenu?.hidden)toggleShapePicker();
    const selectedIndex=Math.max(0,shapeOptions.findIndex(option=>option.classList.contains('is-selected')));
    focusShapeOption(event.key==='ArrowUp'?Math.max(0,selectedIndex-1):Math.min(shapeOptions.length-1,selectedIndex+1));
  });
  shapeMenu?.addEventListener('keydown',event=>{
    if(!routeActive)return;
    const current=Math.max(0,shapeOptions.indexOf(document.activeElement));
    if(event.key==='ArrowDown'){event.preventDefault();focusShapeOption((current+1)%shapeOptions.length);}
    else if(event.key==='ArrowUp'){event.preventDefault();focusShapeOption((current-1+shapeOptions.length)%shapeOptions.length);}
    else if(event.key==='Home'){event.preventDefault();focusShapeOption(0);}
    else if(event.key==='End'){event.preventDefault();focusShapeOption(shapeOptions.length-1);}
    else if(event.key==='Escape'){event.preventDefault();closeShapePicker();shapeTrigger?.focus();}
  });
  topMetal?.addEventListener('change',()=>{if(!routeActive)return;syncMetalPicker(topMetal.value);applyTopFilters();});
  topShape?.addEventListener('change',()=>{if(!routeActive)return;syncShapePicker(topShape.value);applyTopFilters();});
  metalSelect?.addEventListener('change',()=>{if(!routeActive)return;refreshAfterMetal();push('ring_setting_metal_changed',{setting_id:selectedProductId,metal_type:metalSelect.value});});
  caratSelect?.addEventListener('change',()=>{if(!routeActive)return;refreshAfterCarat();push('ring_setting_gold_carat_changed',{setting_id:selectedProductId,gold_carat:caratSelect.value});});
  shapeSelect?.addEventListener('change',()=>{if(!routeActive)return;updateSelectedVariant();push('ring_setting_shape_changed',{setting_id:selectedProductId,setting_shape:shapeSelect.value});});

  const syncRoute=()=>{
    const next=isNativeRoute();
    if(next===routeActive)return;
    routeActive=next;
    if(!routeActive){closeMetalPicker();closeShapePicker();return;}
    syncMetalPicker(topMetal?.value||'yellow-gold');
    syncShapePicker(topShape?.value||'');
    applyTopFilters();
    push('native_setting_picker_view',{settings_on_page:cards.length,full_collection_count:Number(root.dataset.collectionCount||0)});
  };
  window.addEventListener('it:ring-route-change',syncRoute);
  syncRoute();
})();
